interface IconProps {
  color?: string
  className?: string
}

export default function TeamTabIcon({ color, className }: IconProps) {
  return (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.625 5.25C1.64062 5.25 0.875 4.48438 0.875 3.5C0.875 2.54297 1.64062 1.75 2.625 1.75C3.58203 1.75 4.375 2.54297 4.375 3.5C4.375 4.48438 3.58203 5.25 2.625 5.25ZM14.875 5.25C13.8906 5.25 13.125 4.48438 13.125 3.5C13.125 2.54297 13.8906 1.75 14.875 1.75C15.832 1.75 16.625 2.54297 16.625 3.5C16.625 4.48438 15.832 5.25 14.875 5.25ZM15.75 6.125C16.707 6.125 17.5 6.91797 17.5 7.875V8.75C17.5 9.24219 17.0898 9.625 16.625 9.625H14.8203C14.6289 8.33984 13.8633 7.24609 12.7422 6.64453C13.0703 6.34375 13.5078 6.125 14 6.125H15.75ZM8.75 6.125C7.05469 6.125 5.6875 4.75781 5.6875 3.0625C5.6875 1.39453 7.05469 0 8.75 0C10.418 0 11.8125 1.39453 11.8125 3.0625C11.8125 4.75781 10.418 6.125 8.75 6.125ZM10.8281 7C12.5781 7 14 8.42188 14 10.1719V10.9375C14 11.6758 13.3984 12.25 12.6875 12.25H4.8125C4.07422 12.25 3.5 11.6758 3.5 10.9375V10.1719C3.5 8.42188 4.89453 7 6.64453 7H6.86328C7.4375 7.27344 8.06641 7.4375 8.75 7.4375C9.40625 7.4375 10.0352 7.27344 10.6094 7H10.8281ZM4.73047 6.64453C3.60938 7.24609 2.84375 8.33984 2.65234 9.625H0.875C0.382812 9.625 0 9.24219 0 8.75V7.875C0 6.91797 0.765625 6.125 1.75 6.125H3.5C3.96484 6.125 4.40234 6.34375 4.73047 6.64453Z"
        fill={color ?? '#ffffff'}
      />
    </svg>
  )
}
